import { Badge, Button, Space, Typography } from 'antd'

const { Title } = Typography

interface Props {
  title: string
  showButton?: boolean
  level?: 4 | 1 | 5 | 2 | 3 | undefined
  toolbar?: React.ReactNode
  badge?: number
  type?: 'default' | 'sympa'
}

export const PageTitle = ({
  title,
  showButton = true,
  level = 4,
  toolbar,
  badge,
  type = 'default',
}: Props) => {
  return (
    <Space
      className="space-between align-items-center w-full"
      wrap={type === 'sympa'}
    >
      <Space direction="horizontal" style={{ alignItems: 'baseline' }}>
        <Title
          level={level}
          style={{
            margin: 0,
            wordBreak: 'normal',
          }}
          className={type === 'sympa' ? 'title-sympa' : ''}
        >
          {title}
        </Title>
        <Badge
          count={badge}
          style={{
            position: 'relative',
            bottom: '5px',
          }}
        />
      </Space>
      <Space direction="horizontal">{toolbar && toolbar}</Space>
    </Space>
  )
}

export default PageTitle
